'use strict';

angular.module('AcaApp').factory('MetaService',
[
  'MetaResource',
  '$q',
  function(ImportResource, $q){
    var metaData = {};
    var resp = {
      /**
       * Will get from localstorage the metadata, if it wasnt loaded before, will load, cache, and return the metadata
       * @param  {String} fchar Fchar of the form, that we are fetching the metadata
       * @return {Promise}       Returns the promise with the metadata as an array
       */
      getMetaByFchar: function(fchar){
        var metaName;
        if(fchar == '-') {
          metaName = 'Common';
        };
        metaName = (metaName || fchar);
        if(metaData['meta_' + metaName]) {
          return $q.when(metaData['meta_' + metaName]);
        }
        else{
          return this.loadMetaByFchar(fchar).then(function(data){
            metaData['meta_' + metaName] = data.result;
            return data.result;
          });
        }
      },
      /**
       * Load the the metadata from the BE and return the promise with the data.
       * @param  {String} fchar Fchar of the form to load the meta data
       * @return {Promise}       Returns the promise with the meta as an array.
       */
      loadMetaByFchar: function(fchar){
        var rpcConfig = {method: 'GetMetadata', params: [fchar]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      /**
       * This method will be declared but not used, just in case in future we want to pre-load the metadata.
       */
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      initMetaData: function(){
        this.loadMetaByFchar('1').then(function(data){
          metaData.meta_1 = data.result;
        });
        this.loadMetaByFchar('0').then(function(data){
          metaData.meta_1 = data.result;
        });
        this.loadMetaByFchar('X5B').then(function(data){
          metaData.meta_X5B = data.result;
        });
        this.loadMetaByFchar('X5C').then(function(data){
          metaData.meta_X5C = data.result;
        });
        this.loadMetaByFchar('-').then(function(data){
          metaData.meta_Common = data.result;
        });
        this.loadMetaByFchar('X4B').then(function(data){
          metaData.meta_Common = data.result;
        });
        this.loadMetaByFchar('X4C').then(function(data){
          metaData.meta_Common = data.result;
        });
      }
    };
    return resp;
  }
]);